document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('ContactForm');
    const emailInput = document.getElementById('ContactForm-email');
    const emailError = document.getElementById('ContactForm-email-error');
    const formMessage = document.getElementById('form-message');
    const submitButton = form.querySelector('button[type="submit"]');

    form.setAttribute('novalidate', true);

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }


    emailInput.addEventListener('input', function () {
      const email = emailInput.value.trim();
      if (!isValidEmail(email)) {
        emailError.style.display = 'block';
      } else {
        emailError.style.display = 'none';
      }
    });


    submitButton.addEventListener('click', function (e) {
      e.preventDefault();

      const email = emailInput.value.trim();

      if (!isValidEmail(email)) {
        emailError.style.display = 'block';
        emailInput.focus();
        return;
      }

      emailError.style.display = 'none';
      formMessage.textContent = '';

      form.submit();
    });
});